// packages/components/src/agent_profile/showcase/SocialImpactCard.tsx
import React from 'react';
import { Card, Button } from '@dopomogai/ui';
import { HeartHandshake } from 'lucide-react';

type Accent = 'emerald' | 'teal' | 'sky';

type Props = {
  title?: string;
  oneLiner?: string;
  bullets?: string[];
  learnMoreUrl?: string;
  className?: string;
  accent?: Accent;
};

function accentToClasses(accent: Accent) {
  switch (accent) {
    case 'teal':
      return { bg: 'bg-teal-50', text: 'text-teal-900', icon: 'text-teal-700' };
    case 'sky':
      return { bg: 'bg-sky-50', text: 'text-sky-900', icon: 'text-sky-700' };
    case 'emerald':
    default:
      return { bg: 'bg-emerald-50', text: 'text-emerald-900', icon: 'text-emerald-700' };
  }
}

export function SocialImpactCard({
  title = 'Social impact',
  oneLiner = '33% of platform revenue funds non‑profit AI deployments.',
  bullets = ['Transparent monthly reporting', 'Open-sourced playbooks where possible'],
  learnMoreUrl = '/blog/impact-parity',
  className,
  accent = 'emerald',
}: Props) {
  const c = accentToClasses(accent);

  return (
    <Card className={className} noPadding>
      <div className={['px-5 py-4 border-b-2 border-black rounded-t-xl', c.bg, c.text].join(' ')}>
        <div className="flex items-center gap-2">
          <HeartHandshake size={20} className={c.icon} />
          <h3 className="text-lg font-extrabold leading-tight">{title}</h3>
        </div>
      </div>
      <div className="p-5">
        <p className="text-slate-800">{oneLiner}</p>
        {bullets && bullets.length > 0 && (
          <ul className="mt-3 list-disc pl-5 text-sm text-slate-700 space-y-1">
            {bullets.map((b, i) => (
              <li key={i}>{b}</li>
            ))}
          </ul>
        )}
        {learnMoreUrl && (
          <div className="mt-4">
            <Button
              variant="ghost"
              text="Learn more"
              onClick={() => window.open(learnMoreUrl, '_self')}
            />
          </div>
        )}
      </div>
    </Card>
  );
}

export default SocialImpactCard;
